<template>
    <vue-scroll id="header" :ops="scroll_options">
        <div class="inline" valign="center" justify="between">
            <div class="header-left inline " valign="center">
                <img class="logo" src="./../assets/img/logo.svg">
                <div id="nav" class="inline" valign="center">
                    <router-link to="/parking">
                        <strong>Парковки</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.parking['all'] && !$store.state.settings.parking['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/parking_transaction">
                        <strong>Транзакции парковок</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.parking_transaction['all'] && !$store.state.settings.parking_transaction['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/transactions_user">
                        <strong>Транзакции пользователей</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.transactions_user['all'] && !$store.state.settings.transactions_user['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/users">
                        <strong>Юзеры</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.users['all'] && !$store.state.settings.users['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/booking">
                        <strong>Букинг</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.booking['all'] && !$store.state.settings.booking['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/booking_request">
                        <strong>Запросы букинга</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.booking_request['all'] && !$store.state.settings.booking_request['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/authorization">
                        <strong>Верификации</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.authorization['all'] && !$store.state.settings.authorization['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/feedback">
                        <strong>Отзывы</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.feedback['all'] && !$store.state.settings.feedback['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/coupon">
                        <strong>Купоны</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.coupon['all'] && !$store.state.settings.coupon['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/coupon_type">
                        <strong>Типы купонов</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.coupon_type['all'] && !$store.state.settings.coupon_type['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/owner">
                        <strong>Собственники</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.owner['all'] && !$store.state.settings.owner['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                    <router-link to="/email_case">
                        <strong>Кейсы</strong>
                        <span v-if="showSettingsBtn" :class="{_active: $store.state.settings.email_case['all'] && !$store.state.settings.email_case['all'].value}" @click.stop.prevent="$emit('toggleSettings', $event)">настройка</span>
                    </router-link>
                </div>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
export default {
    props: ['data_status'],
    data () {
        return {
            scroll_options: {
                vuescroll: {
                    mode: 'native',
                },
                bar: {
                    background: '#585858'
                }
            }
        }
    },
    computed: {
        showSettingsBtn () {
            return !this.$route.params.id && this.data_status == ''
        }
    }
}
</script>